export default __webpack_public_path__ + "static/media/selectAndSaveState.27187f83.png";